/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { EvidencePart } from "@interfaces/Interfaces";
import "./EvidenceParts.css";
import { IonItem, IonRadio, IonRadioGroup } from "@ionic/react";
import { Text, View } from "@react-pdf/renderer";
import { getDisplayTitleForPDFExport } from "@utils/stringUtils";
import classNames from "classnames";

type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  definition: EvidencePart;
  onValueChanged?: (value: any) => void;
  data?: any;
  isDisplay?: boolean;
  isPDF?: boolean;
  pdfStyles: any;
  initialValue?: any;
  id: string;
};

const RadioButton: React.FC<Props> = ({
  definition,
  onValueChanged,
  data,
  isDisplay,
  isPDF,
  pdfStyles,
  initialValue,
  id,
}) => {
  const [value, setValue] = useState<string>(initialValue || "");
  const [listValues, setListValues] = useState<string[]>([]);

  useEffect(() => {
    const getListValues = (): void => {
      const values = definition?.["List of values"];

      if (values && values.length > 0) {
        let strings = values.split("\n");
        strings = strings.filter((item) => item.length > 0);

        setListValues(strings);
      }
    };

    definition && getListValues();
  }, [definition]);

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    }
  }, [initialValue]);

  const valueChanged = (event: any): void => {
    const _value = event.detail.value;

    setValue(_value);
    onValueChanged && onValueChanged(_value);
  };

  useEffect(() => {
    if (!initialValue?.length) {
      setValue("");
    }
  }, [id]);

  if (isPDF) {
    return (
      <View>
        <Text style={pdfStyles.reflectionHeader}>{getDisplayTitleForPDFExport(definition)}</Text>
        <Text style={pdfStyles.evidenceDate}>{data}</Text>
      </View>
    );
  }

  if (isDisplay) {
    return (
      <div className="readEvidenceBlock">
        <div className="readEvidenceHeader">{definition["Display Title"] || definition.Name}</div>
        <div className="readEvidenceText">{data}</div>
        <div className="mt-4 h-[1px] w-full bg-grey-30" />
      </div>
    );
  }

  return (
    <div>
      <IonRadioGroup
        color="light"
        id="editRoleRadioGroup"
        value={value}
        onIonChange={valueChanged}
      >
        {listValues.map((item) => {
          return (
            <div key={item}>
              <IonItem className="evidencePartsRadioContainer">
                <IonRadio
                  aria-label={item}
                  mode="md"
                  value={item}
                  justify="space-between"
                  className={classNames("evidencePartsRadioLabel text-wrap text-17px tracking-[-0.3]", {
                    "!font-semibold": value === item,
                  })}
                >
                  {item}
                </IonRadio>
              </IonItem>
            </div>
          );
        })}
      </IonRadioGroup>
    </div>
  );
};

export default RadioButton;
